import React from 'react';
import './TrustBar.css';

const TRUST_ITEMS = [
  { icon: 'fa-solid fa-shield-halved',  label: '100% Authentic',    sub: 'Genuine, quality-checked pieces' },
  { icon: 'fa-solid fa-truck-fast',     label: 'Fast Shipping',     sub: 'Dispatched within 24–48 hrs' },
  { icon: 'fa-brands fa-whatsapp',      label: 'WhatsApp Support',  sub: 'Real answers, real quick' },
  { icon: 'fa-solid fa-heart',          label: 'Handpicked Quality',sub: 'Curated, not mass-produced' },
];

const TrustBar: React.FC = () => (
  <section className="trust-bar">
    <div className="container trust-row">
      {TRUST_ITEMS.map(item => (
        <div key={item.label} className="trust-item">
          <span className="trust-icon"><i className={item.icon} aria-hidden="true" /></span>
          <span className="trust-text">
            <span className="trust-label">{item.label}</span>
            <span className="trust-sub">{item.sub}</span>
          </span>
        </div>
      ))}
    </div>
  </section>
);

export default TrustBar;
